import type { ElementType } from "react";
import {
  ClusterIcon,
  ColumnIcon,
  DatasetsIcon,
  FileAssetIcon,
  PipelineIcon,
  SchemaIcon,
  TableIcon,
  TaskIcon,
  TransformationIcon,
} from "@ui-icons";
import type { AssetItemProps } from "./AssetNameWithIcon.props";

export const getMetadataByAssetType = (
  type: AssetItemProps["type"]
):
  | {
      tooltipTitle: string;
      Icon: ElementType;
    }
  | undefined => {
  switch (type) {
    case "dataset":
      return {
        tooltipTitle: "Dataset",
        Icon: DatasetsIcon,
      };
    case "schema":
      return {
        tooltipTitle: "Dataset",
        Icon: SchemaIcon,
      };
    case "input_table":
    case "input table":
    case "created_table":
    case "table":
    // dbt materialisations, which the backend paths as tables
    case "incremental":
    case "materialized_view":
    case "seed":
    case "source":
      return {
        tooltipTitle: "Dataset",
        Icon: TableIcon,
      };
    case "input_file":
    case "input file":
    case "file":
      return {
        tooltipTitle: "File",
        Icon: FileAssetIcon,
      };
    case "column":
      return {
        tooltipTitle: "Column",
        Icon: ColumnIcon,
      };
    case "task":
      return {
        tooltipTitle: "Task",
        Icon: TaskIcon,
      };
    case "transformation":
    case "tf":
    // a dbt script model, which the backend paths as a tf
    case "script":
      return {
        tooltipTitle: "TF",
        Icon: TransformationIcon,
      };
    case "pipeline":
      return {
        tooltipTitle: "Pipeline",
        Icon: PipelineIcon,
      };
    case "cluster":
    case "compute":
      return {
        tooltipTitle: "Compute cluster",
        Icon: ClusterIcon,
      };
  }
};
